import 'babel-polyfill';
import 'angular';
import 'jquery';
import 'angular-i18n/angular-locale_cs-cz';
import 'tr-ng-grid';
import 'angular-translate';
import 'angular-loggly-logger';
import 'angular-ui-notification';
require('../node_modules/angular-bootstrap-confirm/dist/angular-bootstrap-confirm.js');
import 'angular-hotkeys';
import './assets/multiple-select';
import 'angular-moment';

if (!HTMLCanvasElement.prototype.toBlob) {
	Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
		value: function (callback, type, quality) {
			var canvas = this;
			setTimeout(function() {
				var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
					len = binStr.length,
					arr = new Uint8Array(len);
				
				for (var i = 0; i < len; i++ ) {
					arr[i] = binStr.charCodeAt(i);
				}
				
				callback( new Blob( [arr], {type: type || 'image/png'} ) );
			});
		}
	});
}


// WEBPACK FOOTER //
// build/vendor.js